function mapEvent(mapType, options, history, dashboardType) {
  let stateDash = dashboardType + 'StateDashboard'
  let msaDash = dashboardType + 'MSADashboard'
  let hash = undefined
  if (mapType !== undefined && mapType === 'CIACCURACY') {
                if ('state' in this.options) {
                  hash = `state-${this.options.state}`
                  history.push({ hash: hash })
                } else if ('cbsa' in this.options) {
                  hash = `msa-${this.options.cbsa}`
                  history.push({ hash: hash })
                }
              } else if (mapType !== undefined && mapType === 'FLUMAP') {
                if ('state' in this.options) {
                  hash = `state-${this.options.state}`
                  history.push({ hash: hash })
                } else if ('cbsa' in this.options) {
                  hash = `metro-${this.options.cbsa}`
                  history.push({ hash: hash })
                }
              } else if (mapType !== undefined && mapType === 'VUL') {
                // console.log(this.options.projected_Pct)
                if ('state' in this.options) {
                  if (
                    this.options.projected_Pct === 0 ||
                    this.options.projected_Pct === undefined
                  ) {
                  } else {
                    hash = `state-${this.options.stateId}`
                    history.push({ hash: hash })
                  }
                }
              } else if (mapType !== undefined && mapType === 'COVERAGEMAP') {
              }
              else if (mapType !== undefined && mapType === 'RSVMAP' && 'state' in options) {
    hash = `/forecasts/${stateDash}/STATE/${options.state}`
    history.push(hash)
  } else if (
    mapType === 'RSVMAPMSA' &&
    'state' in options &&
    options.geo_parent !== 'US'
  ) {
    hash = `/forecasts/${msaDash}/${options.geo_parent.split(',')[0]}/MSA/${options.state}`
    history.push(hash)
  } else if (
    mapType === 'RSVMAPMSA' &&
    'state' in options &&
    options.geo_parent === 'US'
  ) {
    window.location.href = `/${stateDash}/STATE/${options.state}`
  } else if (
    mapType === 'RSVMAPCDO' &&
    'state' in options &&
    options.geo_parent !== 'US'
  ) {
    window.location.href = `/${msaDash}/${options.geo_parent.split(',')[0]}/MSA/${options.state}`
  } else if (
    mapType === 'RSVMAPCDO' &&
    'state' in options &&
    options.geo_parent === 'US'
  ) {
    window.location.href = `/${stateDash}/STATE/${options.state}`
  }
  else if (mapType !== undefined && mapType === 'COVIDMAP' && 'state' in options) {
    hash = `/forecasts/${stateDash}/STATE/${options.state}`
    history.push(hash)
  } 
  else if (mapType !== undefined && mapType === 'COVIDMAPMSA' && 'state' in options && options.geo_parent === 'US')
    {
    window.location.href = `/forecasts/${stateDash}/STATE/${options.state}`
  }
  else if (mapType !== undefined && mapType === 'COVIDMAPMSA' && 'state' in options && options.geo_parent !== 'US')
    {
    hash = `/forecasts/${msaDash}/${options.geo_parent.split(',')[0]}/MSA/${options.state}`
    history.push(hash)
  }
   else if (mapType !== undefined && mapType === 'FLUMAPMSA' && 'state' in options && options.geo_parent === 'US')
    {
    window.location.href = `/FluStateDashboard/STATE/${options.state}`
  }
  else if (mapType !== undefined && mapType === 'FLUMAPMSA' && 'state' in options && options.geo_parent !== 'US')
    {     
  //  hash = `/forecasts/${msaDash}/${options.geo_parent.split(',')[0]}/MSA/${options.state}`
    hash = `/FluMSADashboard/${options.geo_parent.split(',')[0]}/MSA/${options.state}`
    history.push(hash)
  }
}


export default mapEvent
